export default __webpack_public_path__ + "static/media/PRY.da41c95b.svg";